import { DOMAIN_REFRESHER_FRAGMENT } from 'features/inventory/domain/api/fragments/domainRefresher'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_DOMAIN_REFRESHER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${DOMAIN_REFRESHER_FRAGMENT}
  ${ERROR_FRAGMENT}

  mutation updateDomainRefresher($input: UpdateDomainRefresherInput!) {
    updateDomainRefresher(input: $input) {
      domainRefresher {
        ...DomainRefresherFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
